<!-- *ngIf="isShown" -->
<div class="card amenities-cards card-with-no-padding">
    <div class="card-head pr-0">
        <div class="row w-100 padding-left align-items-center">
            <div class="col-10 pl-1">
                <div class="title font-24 fontSemiBold">{{'content3.Amenities' | translate}}</div>
            </div>
            <div class="col-2 text-right pl-auto pr-0">
                <button type="button" class="btn btn-with-icon-transparent" *ngIf="amenitiesData?.canAdd" (click)="openAmenitiesForm()">
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </div>

    </div>

    <div *ngIf='dataLoading' class="dataLoading">
      <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>

    <ng-container *ngIf="!dataLoading">
      <div class="card-body py-0" *ngIf="amenitiesList.length; else dataEmpty">
        <ul class="nav nav-tabs scrollable-cards" id="amenities-slider"
            [hidden]="dataLoading" (mousedown)="startDragging($event, false)"
            (mouseup)="stopDragging($event, false)" (mouseleave)="stopDragging($event, false)"
            (mousemove)="moveEvent($event)">
            <li class="nav-item" *ngFor="let item of amenitiesList; index as index">
                <div class="card">
                  <div class="img-container">
                    <img [src]="item.icon" alt="">
                  </div>
                  <p class="fontMedium font-16 text-center">{{item.name}}</p>
                </div>
            </li>
        </ul>
      </div>

      <ng-template #dataEmpty>
        <div class="card-content">
          <empty-state [title]='"content4.No amenities have been added yet." | translate'
            [img]="'/assets/images/icons/floors-empty.svg'"></empty-state>
          <a class="btn-light mt-1" mat-stroked-button (click)="openAmenitiesForm()" *ngIf="amenitiesData?.canAdd">
            {{'content4.Add Amenities' | translate}}
          </a>
        </div>
      </ng-template>
    </ng-container>
</div>
